import { z } from "zod"

export const BOX_SLOT_PARTICIPANTS_LIMIT_MIN = 1
export const BOX_SLOT_PARTICIPANTS_LIMIT_MAX = 9999
export const BOX_SLOT_PARTICIPANTS_DEFAULT_VALUE = 10
export const BOX_SLOT_DURATION_DEFAULT_VALUE = 60

export const BoxSlotTypeOf = "SLOT"

export const BoxSlotParticipationSchema = z
  .object({
    limitStart: z.number().nullable(),
    limitEnd: z.number().nullable(),
    limitCancel: z.number().nullable(),
  })
  .meta({ id: "BoxSlotParticipationSchema" })

export type BoxSlotParticipation = z.infer<typeof BoxSlotParticipationSchema>
